let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kYB4G")).then(() => parcelRequire('8Nh1K'));